import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import PackImg from './PackImg';
import KrispButton from './KrispButton';

export default function ProductCard({ sku, index = 0, compact = false }) {
  const { flavor: f, variant: v } = sku;
  const navigate = useNavigate();

  return (
    <motion.div
      data-testid={`pack-card-${sku.key}`}
      data-cursor="expand"
      data-cursor-color={f.color}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay: (index % 3) * 0.08 }}
      className="card-pop relative rounded-3xl bg-white/70 border-2 border-cocoa p-5 flex flex-col overflow-hidden"
    >
      <div className="absolute inset-x-0 top-0 h-2" style={{ background: f.color }} />
      <span className="absolute top-5 left-4 z-10 rounded-full px-3 py-1 text-[10px] font-black tracking-[0.2em] text-cream bg-cocoa">{v.sub}</span>
      <span className="absolute top-5 right-4 z-10 h-11 px-3 rounded-xl bg-cocoa text-kyellow flex items-center gap-1.5 leading-none">
        <Zap size={14} className="fill-kyellow" /><span className="font-display text-lg">{v.protein}</span>
      </span>

      <Link to={`/product/${f.slug}`} data-testid={`pack-link-${sku.key}`} className="block">
        <div className="pt-12 pb-4 chip-drift" style={{ '--t': `${6 + (index % 3)}s`, '--r': '0deg' }}>
          <PackImg f={f} variant={v.id} className={`mx-auto ${compact ? 'h-44' : 'h-60'}`} testid={`pack-img-${sku.key}`} />
        </div>
        <p className="font-display text-3xl leading-none text-cocoa">{f.name}</p>
        <p className="font-cond text-[11px] tracking-[0.22em] text-cocoa/60 mt-1">{f.hook} · {v.protein} PROTEIN</p>
      </Link>

      <div className="flex items-end justify-between mt-4">
        <p className="font-display text-4xl leading-none" data-testid={`pack-price-${sku.key}`}>₹{v.price}</p>
        <span className="rounded-full border-2 border-cocoa/20 px-2.5 py-1 text-[9px] font-black tracking-widest text-cocoa/60">{v.sub}</span>
      </div>

      <KrispButton testid={`pack-add-${sku.key}`} color={f.color} className="w-full mt-4 !py-3 !text-sm"
        onClick={() => navigate(`/checkout?add=${f.slug}`)}>
        ADD TO CART · ₹{v.price}
      </KrispButton>
    </motion.div>
  );
}
